import { provideHttpClient } from '@angular/common/http';
import {  ApplicationConfig, InjectionToken, importProvidersFrom, inject } from '@angular/core';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { provideFuse } from '@fuse';
import { provideAuth } from 'app/core/auth/auth.provider';
import { mockApiServices } from 'app/mock-api';
import { EmailValidators, PhoneValidators, CapValidators, PivaValidators, CfValidators, fieldMatchValidator, CapValidatorMessage, CfValidatorMessage, EmailValidatorMessage, PhoneValidatorMessage, PivaValidatorMessage, minLengthValidationMessages, RequireMatchValidators, RequireMatchMessage, EmailAsyncValidator, UploadValidator, atLeastOneCheckboxChecked, atLeastOne, dateRange, AutocompleteMatchValidators, atLeastOneCheckboxCheckedEmporio, maxLengthValidationMessage, maxValidationMessage, minLengthValidationMessage, minValidationMessage, atLeastOneElement } from './formly/formly-function.validators';
import { FormlyMaterialModule } from '@ngx-formly/material';
import { FormlyModule, FORMLY_CONFIG } from '@ngx-formly/core';
import { PanelDocumentiComponent } from './formly/panel-estremi-doc.wrapper';
import { PanelEmailComponent } from './formly/panel.wrapper';
import { MatUploadTypeComponent } from './formly/mat-upload/mat-upload.type';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { PanelComponent } from './formly/panel.type';
import { PresentataReadComponent } from './formly/presentata-read.type';
import { FormlyFieldStepperH } from './formly/stepper-h.type';
import { RepeatTypeComponent } from './formly/base/mat-repeat.type';
import { RepeatReadTypeComponent } from './formly/repeat-read-type.component';
import { SpinnerTypeComponent } from './formly/spinner.type';
import { StarRatingTypeComponent } from './formly/rating-star.type';
import { FormlyMatDatepickerModule } from '@ngx-formly/material/datepicker';
import { Validators } from '@angular/forms';
import { FormlyFieldStepperV } from './formly/stepper-v.type';
import { FormlyFieldStepper } from './formly/stepper/stepper.type';
import { PanelPresentataComponent } from './formly/panel-presentata.type';
import { AlertPresentataComponent } from './formly/alert-presentata';
import { addonsExtension, ariaLabelExtension } from './formly/addons.extension';
import { FormlyWrapperAddons } from './formly/addons.wrapper';
import { FormlyFieldAllSteps } from './formly/allsteps/allsteps.type';
import { AlertAttenzioneComponent } from './formly/alert-attenzione';
import { PanelProtocollata } from './formly/panel.protocollata';
import { PagamentoComponent } from './formly/pagamento';
import { UploadControlComponent } from './formly/upload.component';
import { AlertWarningComponent } from './formly/alert-warning';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { CustomPaginator } from './modules/shared/custom-paginator-configuration';
import { FormlyFieldBackend } from './formly/backend/backend.type';
import { PagoPaComponent } from './formly/pagopa/pagopa.type';
import { FormlyMatNativeSelectModule } from '@ngx-formly/material/native-select';
import { RiepilogoType } from './formly/riepilogo.type';
import { AllegatiRiepilogoComponent } from './formly/allegati-riepilogo/allegati-riepilogo.type';
import { MatDateRangePickerTypeComponent } from './formly/base/mat-daterangepicker.type';
import { InputReadType } from './formly/input-read.type';
import { DateReadType } from './formly/date-read.type';
import { MultiSelectReadType } from './formly/multiselect-read.type';
import { MultiSelectTypeComponent } from './formly/multiselect.type';
import { SelectReadType } from './formly/select-read.type';
import { MultiCheckboxReadType } from './formly/multicheckbox-read.type';
import { FormlyFieldFile } from './formly/file-type.type';
import { AlertNoteComponent } from './formly/alert-note';
import { CheckboxReadType } from './formly/checkbox-read.type';
import { RadioReadType } from './formly/radio-read.type';
import { MAT_AUTOCOMPLETE_DEFAULT_OPTIONS } from '@angular/material/autocomplete';
import { PanelStepComponent } from './formly/panel-step-wrapper';
import { LinkDownload } from './formly/link-download.type';
import { RatingTypeComponent } from './formly/rating-steps.type';
import { StepperFormlyRating } from './formly/rating-stepper.type';
import { GoogleMapTypeComponent } from './formly/g-map/g-map.component';
import { GoogleMapSVTypeComponent } from './formly/g-map-sv/g-map-sv.component';
import { PanelPrivacyComponent } from './formly/panel-privacy.type';
import { FormlyWrapperRead } from './formly/panel-readpanel';
import { TopBorderPanel } from './formly/top-border-panel.type';
import { AutocompleteServiceTypeComponent } from './formly/autocomplete-sevice.type';
import { CardPanel } from './formly/card-panel.type';
import { GroupBorderPanel } from './formly/group-border-panel.type';
import { appRoutes } from './routes/app.routes';
import { PanelIstruttoreComponent } from './formly/panel-istruttore.wrapper';
import { FormlyPresetModule } from '@ngx-formly/core/preset';
import { MatDatepickerTypeComponent } from './formly/base/mat-datepicker.type';
import { MatTextAreaTypeComponent } from './formly/base/mat-textarea.type';
import { MatInputTypeComponent } from './formly/base/mat-input.type';
import { MatRadioTypeComponent } from './formly/base/mat-radio.type';
import { MatCheckboxTypeComponent } from './formly/base/mat-checkbox.type';
import { MatSelectTypeComponent } from './formly/base/mat-select.type';
import { MatMultiCheckboxTypeComponent } from './formly/base/mat-multicheckbox.type';
import { MatAutocompleteTypeComponent } from './formly/base/mat-autocomplete.type';
import { provideIcons } from './core/icons/icons.provider';
import { TranslocoHttpLoader } from './core/transloco/transloco.http-loader';
import { MatTimePickerTyComponent } from './formly/base/mat-timepicker.type';
import { provideTransloco } from '@jsverse/transloco';
import { MultiSelectType } from './formly/base/mat-multiselect.type';


export const MY_DATE_FORMATS = {
    parse: {
        dateInput: 'D/M/YYYY',
    },
    display: {
        dateInput: 'DD/MM/YYYY',
        monthYearLabel: 'MMMM YYYY',
        dateA11yLabel: 'DD MM YYYY',
        monthYearA11yLabel: 'MMMM YYYY',
    },
};


export interface BackendUrls {
    backendApiUrl: string;
    backendComuniUrl: string;
    backendPagopaUrl: string;
    backendSportelloTDUrl: string;
    backendUbicazioneUrl: string;
}
export const BACKEND_URLS = new InjectionToken<BackendUrls>('backendUrls');

export const appConfig: ApplicationConfig = {
    providers: [
        {
            provide: BACKEND_URLS,
            useValue: {
                backendApiUrl: '/api/v1',
                backendComuniUrl: '/api/comuni/v1',
                //backendPagopaUrl: '/api/pagopa/v1',
                //backendUbicazioneUrl: '/api/ubi/v1'

            },
        },
        provideAnimations(),
        provideHttpClient(),
        provideRouter(
            //withHashLocation(),
            appRoutes,
            //withPreloading(PreloadAllModules),
            //withInMemoryScrolling({ scrollPositionRestoration: 'enabled' })
        ),
        // Transloco Config
        provideTransloco({
            config: {
                availableLangs: [
                    {
                        id: 'it',
                        label: 'Italiano',
                    },
                    {
                        id: 'en',
                        label: 'English',
                    },
                    {
                        id: 'tr',
                        label: 'Turkish',
                    },
                ],
                defaultLang: 'it',
                fallbackLang: 'it',
                reRenderOnLangChange: true,
                prodMode: true,
            },
            loader: TranslocoHttpLoader,
        }),
        //MATPAGINATOR
        {
            provide: MatPaginatorIntl, useValue: CustomPaginator()
        },
        // Fuse
        provideAuth(),
        provideIcons(),
        provideFuse({
            mockApi: {
                delay: 0,
                services: mockApiServices,
            },
            fuse: {
                layout: 'classy',
                scheme: 'light',
                screens: {
                    sm: '600px',
                    md: '960px',
                    lg: '1280px',
                    xl: '1440px',
                },
                theme: 'theme-default',
                themes: [
                    {
                        id: 'theme-default',
                        name: 'Default',
                    },
                    {
                        id: 'theme-brand',
                        name: 'Brand',
                    },
                    {
                        id: 'theme-teal',
                        name: 'Teal',
                    },
                    {
                        id: 'theme-rose',
                        name: 'Rose',
                    },
                    {
                        id: 'theme-purple',
                        name: 'Purple',
                    },
                    {
                        id: 'theme-amber',
                        name: 'Amber',
                    },
                ],
            },
        }),
        // Material Date Adapter
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter
        },
        {
            provide: MAT_DATE_FORMATS,
            useValue: MY_DATE_FORMATS
        },
        { provide: MAT_DATE_LOCALE, useValue: 'it-IT' },
        { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'fill' } },
        { provide: MAT_AUTOCOMPLETE_DEFAULT_OPTIONS, useValue: { autoActiveFirstOption: true } },
        // Formly
        importProvidersFrom(
            FormlyMaterialModule,
            FormlyMatDatepickerModule,
            FormlyMatNativeSelectModule,
            FormlyPresetModule,
            FormlyModule.forRoot({
                extras: { checkExpressionOn: 'modelChange', lazyRender: true },
                types: [

                    { name: 'mat-input', component: MatInputTypeComponent, wrappers: ['form-field'], defaultOptions: { validation: { show: true } } },
                    { name: 'mat-textarea', component: MatTextAreaTypeComponent, wrappers: ['form-field'], defaultOptions: { validation: { show: true } }  },
                    { name: 'mat-select', component: MatSelectTypeComponent, wrappers: ['form-field'], defaultOptions: { validation: { show: true } }  },
                    { name: 'mat-radio', component: MatRadioTypeComponent, wrappers: ['form-field'], defaultOptions: { validation: { show: true } }  },
                    { name: 'mat-checkbox', component: MatCheckboxTypeComponent, wrappers: ['form-field'], defaultOptions: { validation: { show: true } }  },
                    { name: 'mat-multicheckbox', component: MatMultiCheckboxTypeComponent, wrappers: ['form-field'], defaultOptions: { validation: { show: true } }  },
                    { name: 'mat-autocomplete', component: MatAutocompleteTypeComponent, wrappers: ['form-field'], defaultOptions: { validation: { show: true } } },
                    { name: 'mat-datepicker', component: MatDatepickerTypeComponent, wrappers: ['form-field'], defaultOptions: { validation: { show: true } } },
                    { name: 'mat-timepicker', component: MatTimePickerTyComponent, wrappers: ['form-field'], defaultOptions: { validation: { show: true } } },
                    { name: 'mat-daterangepicker', component: MatDateRangePickerTypeComponent},,
                    { name: 'mat-multiselect', component: MultiSelectType, wrappers: ['form-field'], defaultOptions: { validation: { show: true } }  },
                    

                    { name: 'input-read', component: InputReadType, wrappers: ['form-field'] },
                    { name: 'date-read', component: DateReadType, wrappers: ['form-field'] },
                    { name: 'select-read', component: SelectReadType, wrappers: ['form-field'] },
                    { name: 'checkbox-read', component: CheckboxReadType },
                    { name: 'radio-read', component: RadioReadType, wrappers: ['form-field'] },
                    // { name: 'multiselect', component: MultiSelectType, wrappers: ['form-field'], defaultOptions: { validation: { show: true } } },
                    { name: 'multiselect-read', component: MultiSelectReadType, wrappers: ['form-field'], defaultOptions: { validation: { show: true } } },
                    { name: 'multicheckbox-read', component: MultiCheckboxReadType, wrappers: ['form-field'], defaultOptions: { validation: { show: true } } },
                    { name: 'presentata-read', component: PresentataReadComponent },
                    { name: 'protocollata', component: PanelProtocollata },
                    { name: 'mat-autocomplete-service', component: AutocompleteServiceTypeComponent, wrappers: ['form-field'], defaultOptions: { validation: { show: true } } },
                    { name: 'mat-upload', component: MatUploadTypeComponent },
                    { name: 'g-map-type', component: GoogleMapTypeComponent },
                    { name: 'g-map-sv-type', component: GoogleMapSVTypeComponent },
                    { name: 'file', component: FormlyFieldFile, wrappers: ['form-field'] },
                    { name: 'myupload', component: UploadControlComponent, wrappers: [] },
                    { name: 'stepper-h', component: FormlyFieldStepperH, wrappers: [] },
                    { name: 'stepper-v', component: FormlyFieldStepperV, wrappers: [] },
                    { name: 'stepper', component: FormlyFieldStepper, wrappers: [] },
                    { name: 'allsteps', component: FormlyFieldAllSteps, wrappers: [] },
                    { name: 'backend', component: FormlyFieldBackend, wrappers: [] },
                    { name: 'repeat', component: RepeatTypeComponent },
                    { name: 'repeat-read', component: RepeatReadTypeComponent },
                    { name: 'presentata', component: PanelPresentataComponent },
                    { name: 'alert-presentata', component: AlertPresentataComponent },
                    { name: 'alert-attenzione', component: AlertAttenzioneComponent },
                    { name: 'alert-warning', component: AlertWarningComponent },
                    { name: 'pagamento', component: PagamentoComponent },
                    { name: 'pagopa', component: PagoPaComponent },
                    { name: 'riepilogo', component: RiepilogoType },
                    { name: 'link', component: LinkDownload },
                    { name: 'elenco-allegati', component: AllegatiRiepilogoComponent },
                    { name: 'rating', component: RatingTypeComponent },
                    { name: 'stepper-rating', component: StepperFormlyRating, wrappers: [] },


                    {
                        name: 'input-uppercase',
                        extends: 'input',
                        defaultOptions: {
                            validation: {
                                show: true
                            },
                            props: {
                                keyup: (field) => {
                                    field.formControl.setValue(field.formControl.value?.toUpperCase())
                                },
                                attributes: {
                                    style: 'text-transform: uppercase',
                                }
                            }
                        },
                    },

                    {
                        name: 'input-lowercase',
                        extends: 'input',
                        defaultOptions: {
                            validation: {
                                show: true
                            },
                            props: {
                                keyup: (field) => {
                                    field.formControl.setValue(field.formControl.value?.toLowerCase())
                                },
                                attributes: {
                                    style: 'text-transform: lowercase',
                                }
                            }
                        },
                    },


                    { name: 'spinner', component: SpinnerTypeComponent },
                    { name: 'star-rating', component: StarRatingTypeComponent },
                    {
                        name: 'input',
                        defaultOptions: {
                            validation: {
                                show: true
                            },
                            props: {
                                min: 0
                            }
                        }
                    },
                    {
                        name: 'datepicker',
                        defaultOptions: {
                            validation: {
                                show: true
                            }
                        }
                    },
                    {
                        name: 'radio',
                        defaultOptions: {
                            validation: {
                                show: true
                            }
                        }
                    },
                    {
                        name: 'select',
                        defaultOptions: {
                            validation: {
                                show: true
                            },
                        }
                    },
                    {
                        name: 'checkbox',
                        defaultOptions: {
                            validation: {
                                show: true
                            }
                        }
                    },
                    {
                        name: 'multicheckbox',
                        defaultOptions: {
                            validation: {
                                show: true
                            }
                        }
                    },
                    {
                        name: 'repeat',
                        defaultOptions: {
                            validation: {
                                show: true
                            }
                        }
                    }
                ],
                wrappers: [
                    { name: 'addons', component: FormlyWrapperAddons },
                    { name: 'panel-estremi', component: PanelDocumentiComponent },
                    { name: 'panel-istruttore', component: PanelIstruttoreComponent },
                    { name: 'alert-note', component: AlertNoteComponent },
                    { name: 'alert-warning', component: AlertWarningComponent },
                    { name: 'panel-email', component: PanelEmailComponent },
                    { name: 'panel', component: PanelComponent },
                    { name: 'panel-privacy', component: PanelPrivacyComponent },
                    { name: 'panel-step', component: PanelStepComponent },
                    { name: 'prova-readpanel', component: FormlyWrapperRead },
                    { name: 'top-panel', component: TopBorderPanel },
                    { name: 'group-panel', component: GroupBorderPanel },
                    { name: 'card-panel', component: CardPanel },

                ],

                extensions: [
                    { name: 'addons', extension: { onPopulate: addonsExtension } },
                    { name: 'default-label', extension: ariaLabelExtension },

                ],

                presets: [
                    {
                        name: 'data',
                        config: {
                            type:'mat-datepicker',
                            wrappers: ['form-field'],
                            validation: {
                                show: true
                            },
                        }
                    },
                    {
                        name: 'email',
                        config: {
                            "key": 'intestatario.email',
                            "type": 'mat-input',
                            "props": {
                                "label": 'INDIRIZZO E-MAIL',
                                "type": 'email',
                                "lowercase": true,
                            },
                            "validators": {
                                "validation": ['email'],
                            }
                        }
                    },
                    {
                        name: 'cf',
                        config: {
                        "type":"mat-input",
                        "props": {
                          "label": 'CODICE FISCALE',
                          "maxLength": 16,
                          "required": true,
                          "uppercase": true,
                          "spidlock":true
                        },
                        "validators": {
                          "validation": ['cf'],
                        }
                      }
                    },
                    {
                        name: "autocomplete-comune",
                        config: {
                            "type":'mat-autocomplete',
                            "expressions": {
                                "props.filter": 'formState.filterComuni',
                            },
                            validators:{
                                validation:['AutocompleteMatch'],
                            }
                        },
                    }
                ],

                validators: [
                    { name: 'email', validation: EmailValidators },
                    { name: 'emailAsync', validation: EmailAsyncValidator },
                    { name: 'phone', validation: PhoneValidators },
                    { name: 'cap', validation: CapValidators },
                    { name: 'p_iva', validation: PivaValidators },
                    { name: 'cf', validation: CfValidators },
                    { name: 'fieldMatch', validation: fieldMatchValidator },
                    { name: 'requiredTrue', validation: Validators.requiredTrue },
                    { name: 'requireMatch', validation: RequireMatchValidators },
                    { name: 'AutocompleteMatch', validation: AutocompleteMatchValidators },
                    { name: 'mat-upload', validation: UploadValidator },
                    { name: 'checkValidator', validation: atLeastOneCheckboxChecked },
                    { name: 'atLeastOneValidator', validation: atLeastOne },
                    { name: 'dateRangeValidator', validation: dateRange },
                    { name: 'emporioCheckValidator', validation: atLeastOneCheckboxCheckedEmporio },
                    { name: 'atLeastOne', validation: atLeastOneElement },


                ],
                validationMessages: [
                    { name: 'required', message: 'Campo obbligatorio' },
                    { name: 'multiCheckBox', message: 'Spuntare almeno una delle opzioni' },
                    { name: 'match', message: "Selezionare una voce dall'elenco (digitare almeno 2 caratteri)" },
                    { name: 'AutocompleteMatch', message: "Selezionare una voce dall'elenco (digitare almeno 1 carattere)" },
                    { name: 'email', message: EmailValidatorMessage },
                    { name: 'phone', message: PhoneValidatorMessage },
                    { name: 'p_iva', message: PivaValidatorMessage },
                    { name: 'cap', message: CapValidatorMessage },
                    { name: 'cf', message: 'codice fiscale non valido' },
                    { name: 'minLength', message: minLengthValidationMessages },
                    { name: 'dateRangeValidator', message: 'La data di inizio deve essere maggiore o uguale alla data di fine' },
                    { name: 'minLength', message: minLengthValidationMessage },
                    { name: 'maxLength', message: maxLengthValidationMessage },
                    { name: 'min', message: minValidationMessage },
                    { name: 'max', message: maxValidationMessage },
                    { name: 'atLeastOne', message: 'Almeno 1 elemento' },


                ],
            })
        ),
    ],
};

